<template>
  <div>
    <div class="mb-4 text-center">
      <span class="number-words">{{ totalWords }} Words</span>
    </div>
    <div class="w-full relative h-10 bg-gray-200 dark:bg-gray-700">
      <div class="line" style="left: 25%">
        <div class="number">10</div>
      </div>
      <div class="line" style="right: 25%">
        <div class="number">30</div>
      </div>
      <div class="h-10 flex dark:bg-gray-300" :style="progessBarStyle"></div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  export default Vue.extend({
    props: {
      totalWords: Number,
      value: Number,
    },
    methods: {},
    computed: {
      progessBarStyle() {
        const totalWords = this.totalWords;
        const maximum = 40;
        let width;
        let backgroundColor;

        if (totalWords < 10) {
          backgroundColor = 'red';
        } else if (this.totalWords <= 30) {
          backgroundColor = '#F5BE30';
        } else {
          backgroundColor = '#30A92E';
        }

        if (totalWords / maximum >= 0.975) {
          width = '100%';
        } else {
          width = `${(totalWords / maximum) * 100}%`;
        }

        return {
          width: width,
          backgroundColor: backgroundColor,
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .number-words {
    font-size: 16px;
  }
  .line {
    border-left: 3px solid #7f89a1;
    height: 100%;
    z-index: 10;
    position: absolute;
  }

  .value {
    margin-left: -6px;
  }

  .number {
    position: absolute;
    top: 50px;
    left: -7px;
  }

  .steps {
    margin-top: -40px;
  }
</style>



// WEBPACK FOOTER //
// AverageComment.vue?2bae0cda